import { inject, Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';
import { from, Observable, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastController: ToastController = inject(ToastController);

  showToast(opts: ToastOptions): Observable<void> {
    return from(this.toastController.create(opts)).pipe(
      switchMap((toast: HTMLIonToastElement) => from(toast.present()))
    );
  }

  presentToast(opts: ToastOptions): void {
    this.toastController.create(opts).then((toast: HTMLIonToastElement) => toast.present());
  }
}
